// extracted by mini-css-extract-plugin
export var divider = "_md-0";
export var labelWrapper = "_md-2";
export var lineSvg = "_md-1";